import { render } from "./EmployeeDetails.vue?vue&type=template&id=d01dcc04&scoped=true"
import script from "./EmployeeDetails.vue?vue&type=script&lang=js"
export * from "./EmployeeDetails.vue?vue&type=script&lang=js"

import "./EmployeeDetails.vue?vue&type=style&index=0&id=d01dcc04&lang=scss&scoped=true"

import exportComponent from "/Users/balbeer.yadav/Development/lmthrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d01dcc04"]])

export default __exports__